import React, {useEffect,useState} from "react";
import Overlay from "../common/Overlay";
import AdditionalInfo from "../AdditionalInfo";
import styled from "styled-components";
import useModal from "../../hooks/useModal";

const Title = styled.div({
  fontColor: "#1F1C43",
  fontSize: 16,
  fontWeight: 400,
  fontFamily: "'pf_highway_sans_pro_lightRg', sans-serif",
});

const Container = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  width: "100%",
  padding: 16,
  borderRadius: 8,
  cursor: "pointer",
});

const UsefulInfo = ({eventData,loading }) => {
    const { isOpen, openModal, closeModal } = useModal();

  return (
    <>
          <Container onClick={(e) => {
              e.preventDefault();
              openModal();
          }}>
        <Title>{orderdetails_resources.UsefulInformation}</Title>
        <img
          src="/Site/images/icons/order-details/arrow-right.svg"
          alt="arrow-right"
          style={{ marginTop: 0, marginBottom: 0, width: 24, height: 24 }}
        />
      </Container>
      <Overlay
        handleClose={closeModal}
        open={isOpen}
        id="order-details-additionalInfo"
        titleText={playdetailsv2_resources.AdditionalInfo}
      >
              <AdditionalInfo hasAdditionalInfoSection inModal loading={loading} eventData={eventData}/>
      </Overlay>
    </>
  );
};

export default UsefulInfo;
